<template>
  <div class="privacy">
    <header-general type="privacy"></header-general>
    <div class="content">
      <nav class="breadcrumb">
        <a href="https://zjy.glodon.com">首页</a>
        >
        <span>用户协议 </span>
      </nav>
      <div class="main-content" style="padding: 0 26px; font-size: 12px; line-height: 26px; color: #666; text-align: justify;">
        <user-agreement></user-agreement>
      </div>
    </div>
    <footer-general type="blocked" style="text-align: center"></footer-general>
  </div>
</template>
<style lang="less">
  @import "./privacy";
</style>

<script>
import HeaderGeneral from '_c/common/Header/HeaderGeneral.vue'
import FooterGeneral from '_c/common/Footer/FooterGeneral.vue'
import UserAgreement from '_c/privacy/src/UserAgreement'
export default {
  components: {
    HeaderGeneral,
    FooterGeneral,
    UserAgreement
  }
}
</script>
